import { render } from "./terms.vue?vue&type=template&id=006cc543"
const script = {}
script.render = render

export default script